/* eslint-disable react/no-array-index-key */
import React from 'react';
import propTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import shortid from 'shortid';
import Swal from 'sweetalert2';
import { createFetch } from '../../utils';
import { forceToMonFri } from '../../components/DateFunction';
import lang from '../../lang';
import '../../styles/guest.scss';
import OperatorList from './operatorList';
const { URL_PREFIX } = window;


const DEFAULT_STATE = {
    viewingList: [],
    selectedView: null,
    viewName: '',
    isPublic: false,
    loading: false,
    selectedObject: '',
    selectedColumn: [],
    choosenObj: null,
    id: null,
    fieldFilter: '',
    filterCriteria: [],
    errorMessage: {},
    isDefault: false,
    cloning: false,
    profileId: '',
    profileList: [],
    sortOrder: [],
};
class ColumnViewing extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign(DEFAULT_STATE);
        this.onSelectedViewChanged = this.onSelectedViewChanged.bind(this);
        this.save = this.save.bind(this);
        this.delete = this.delete.bind(this);
        this.addFilterCriteriaPlaceholder = this.addFilterCriteriaPlaceholder.bind(this);
        const url = new URL(window.location.href);
        this.state.cloning = url.searchParams.get('clone') === 'true';
        this.getProfileList = this.getProfileList.bind(this);
        this.addSortOrderPlaceholder = this.addSortOrderPlaceholder.bind(this);
    }

    async componentWillMount() {
        await this.getAllView();
        await this.getProfileList();
        const { id } = this.props.match.params;
        if (id !== 'new') {
            const selectedViewDetail = this.state.viewingList.find(o => o._id === id) || {};
            if (this.state.cloning) {
                selectedViewDetail.viewName += `(clone-${(Math.random() * 1E2).toFixed(0)})`;
            }
            this.setState({
                selectedView: id,
                viewName: selectedViewDetail.viewName || '',
                selectedColumn: selectedViewDetail.column || [],
                isPublic: selectedViewDetail.isPublic || false,
                id,
                isDefault: selectedViewDetail.isDefault || false,
                filterCriteria: selectedViewDetail.filterCriteria || [],
                sortOrder: selectedViewDetail.sortOrder || [],
                profileId: selectedViewDetail.profileId || '',
            });
        }
    }

    onSelectedViewChanged(e) {
        const { viewingList } = this.state;
        const selectedViewDetail = viewingList.find(o => o._id === e.target.value) || {};
        this.setState({
            selectedView: e.target.value,
            viewName: selectedViewDetail.viewName || '',
            selectedColumn: selectedViewDetail.column || [],
            isPublic: selectedViewDetail.isPublic || false,
            id: e.target.value,
            isDefault: selectedViewDetail.isDefault || false,
            filterCriteria: selectedViewDetail.filterCriteria || [],
        });
    }

    async getAllView() {
        this.setState({ loading: true });
        const { user } = this.props;
        const viewingList = await createFetch({
            path: 'guest/column-viewing',
            method: 'GET',
            accessToken: user.accessToken,
        });
        this.setState({ viewingList: viewingList.records });
        this.setState({ loading: false });
    }

    async getProfileList() {
        const { user } = this.props;
        const profileList = await createFetch({
            path: 'users/profile/list?limit=100',
            method: 'GET',
            body: null,
            accessToken: user.accessToken,
        });
        if (profileList.status === 200) {
            this.setState({
                profileList: profileList.records,
            });
        }
    }

    async save() {
        const {
            loading, id, selectedColumn, viewName, isPublic, filterCriteria, isDefault, cloning, profileId, sortOrder,
        } = this.state;
        const { accessToken } = this.props.user;
        if (loading) return;
        try {
            const body = {
                column: selectedColumn,
                viewName,
                isPublic,
                filterCriteria,
                isDefault,
                profileId,
                sortOrder,
            };
            if (id && !cloning) body.id = this.state.id;
            const result = await createFetch({
                path: 'guest/column-viewing',
                method: id && !cloning ? 'PATCH' : 'POST',
                accessToken,
                body,
            });
            if (result.status === 200) {
                Swal.fire({
                    title: lang.common.success,
                    text: result.message,
                    type: 'success',
                });
                this.setState({
                    loading: false,
                    id: result.result._id || id,
                    errorMessage: {},
                    cloning: false,
                }, this.getAllView);
                return;
            }
            const error = new Error(result.message);
            error.validation = result.validation;
            throw error;
        } catch (error) {
            const errorMessage = {};
            if (error.validation) {
                error.validation.forEach((o) => {
                    errorMessage[o.param] = o.msg;
                });
            }
            this.setState({ loading: false, errorMessage });
            Swal.fire({
                title: lang.common.incomplete,
                text: lang.serverMessage[error.message],
                type: 'error',
            });
        }
    }

    async delete() {
        const res = await Swal.fire({
            title: lang.dialogue.areYouSure,
            text: lang.dialogue.willNotRecover,
            type: 'question',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: lang.common.yes,
            cancelButtonText: lang.common.no,
        });
        if (res.value) {
            if (this.state.loading) return;
            const { accessToken } = this.props.user;
            try {
                const result = await createFetch({
                    path: 'guest/column-viewing/delete',
                    method: 'POST',
                    accessToken,
                    body: {
                        id: this.state.id,
                    },
                });
                if (result.status === 200) {
                    Swal.fire({
                        title: lang.common.success,
                        text: result.message,
                        type: 'success',
                    });
                    this.props.history.push(`${URL_PREFIX}/app/guest-list/${moment(forceToMonFri(new Date())).format('YYYY-MM-DD')}`);
                    return;
                }
                const error = new Error(result.message);
                error.validation = result.validation;
                throw error;
            } catch (error) {
                this.setState({ loading: false });
                Swal.fire({
                    title: lang.titleError,
                    text: lang.serverMessage[error.message] || error.message,
                    type: 'error',
                });
            }
        }
    }

    putInSelectedColumn(objectName, columnName, label, type) {
        const { selectedColumn } = this.state;
        if (selectedColumn.length >= 50) {
            Swal.fire({
                title: lang.titleError,
                text: 'Only 50 column are allowed',
                type: 'warning',
            });
            return;
        }

        const index = selectedColumn.findIndex(o => o.objectName === objectName && o.columnName === columnName);
        if (index === -1) {
            selectedColumn.push({
                objectName, columnName, label, highlighted: false, type,
            });
            this.setState({
                selectedColumn,
            });
        }
    }

    toggleHighlightSelectedCol(index, shiftKey = false) {
        const { selectedColumn } = this.state;
        if (shiftKey === false) {
            for (let i = 0; i < selectedColumn.length; i++) {
                selectedColumn[i].highlighted = false;
            }
        }
        selectedColumn[index].highlighted = !selectedColumn[index].highlighted;
        this.setState({ selectedColumn });
    }

    toggleHighlightAvailableField(index, shiftKey = false) {
        const { choosenObj, selectedColumn } = this.state;
        if (selectedColumn.length >= 50) {
            Swal.fire({
                title: lang.titleError,
                text: 'Only 50 column are allowed',
                type: 'warning',
            });
            return;
        }
        if (shiftKey === false) {
            for (let i = 0; i < choosenObj.fields.length; i++) {
                choosenObj.fields[i].highlighted = false;
            }
        }
        choosenObj.fields[index].highlighted = !choosenObj.fields[index].highlighted;
        this.setState({ choosenObj });
    }

    removeSelectedCol(index) {
        const { selectedColumn } = this.state;
        selectedColumn.splice(index, 1);
        this.setState({ selectedColumn });
    }

    reorderSelectedCol(type = -1) {
        const { selectedColumn } = this.state;
        const index = selectedColumn.findIndex(o => o.highlighted === true);
        if (index + type > -1 && index + type < selectedColumn.length) {
            const data = selectedColumn[index + type];
            selectedColumn[index + type] = selectedColumn[index];
            selectedColumn[index] = data;
            this.setState({ selectedColumn });
        }
    }

    addFilterCriteriaPlaceholder() {
        const { filterCriteria } = this.state;
        if (filterCriteria.length >= 3) return;
        filterCriteria.push({
            objectName: '',
            columnName: '',
            filterValue: '',
            operator: '',
            id: shortid.generate(),
        });

        this.setState({ filterCriteria });
    }

    addSortOrderPlaceholder() {
        const { sortOrder } = this.state;
        if (sortOrder.length >= 3) return;
        sortOrder.push({
            objectName: '',
            columnName: '',
            type: 'asc',
        });

        this.setState({ sortOrder });
    }

    changeFilterCriteria(type, value, index) {
        const { filterCriteria } = this.state;
        filterCriteria[index] = {
            ...filterCriteria[index],
            [type]: value,
        };

        this.setState({ filterCriteria });
    }

    changeSortOrder(type, value, index) {
        const { sortOrder } = this.state;
        sortOrder[index] = {
            ...sortOrder[index],
            [type]: value,
        };

        this.setState({ sortOrder });
    }

    removeFilterCriteria(index) {
        const { filterCriteria } = this.state;
        filterCriteria.splice(index, 1);
        this.setState({ filterCriteria });
    }

    removeSortOrder(index) {
        const { sortOrder } = this.state;
        sortOrder.splice(index, 1);
        this.setState({ sortOrder });
    }

    render() {
        const {
            selectedView, viewingList, viewName, isPublic, loading, selectedObject, selectedColumn, choosenObj, fieldFilter, filterCriteria, errorMessage,
            id, cloning, profileList, profileId, sortOrder,
        } = this.state;

        const url = new URL(window.location.href);
        const date = url.searchParams.get('date') || moment(forceToMonFri(new Date())).format('YYYY-MM-DD');

        return (
            <div id="columnViewing">
                <Link to={`${URL_PREFIX}/app/guest-list/${date}?viewId=${id}`} className="">
                    <i className="fa fa-arrow-left" /> Back
                </Link>
                <h1 className="text-left">Column Configuration {cloning ? '- Clone' : (id ? '- Edit' : '- Create')}</h1>
                <p>In this page you can configure how the guest list should look.</p>
                <div className="header-section">
                    <div className="flex col-sm-6 col-offset-sm-3 col-lg-4 action-btn">
                        <button className="btn btn-alternate" onClick={this.save}>{lang.common.save}</button>
                        {selectedView !== '' && selectedView !== null && !cloning ? <button className="btn btn-danger" onClick={this.delete}>{lang.common.delete}</button> : null}
                        <Link to={`${URL_PREFIX}/app/guest-list/${date}?viewId=${id}`} className="btn btn-default" onClick={this.cancel}>
                            {lang.common.cancel}
                        </Link>
                    </div>
                    <div className="clearfix" />
                </div>
                <p style={{ textAlign: 'center' }}>
                    {loading ? <p style={{ fontSize: 16 }}>Fetching Data...<br /><br /><i className="fa fa-spinner fa-spin fa-3x" /></p> : null}
                </p>
                <div className="row view-name-section">
                    <p className="first-label">Enter Column Configuration Information</p>
                    <div className="col-lg-12">
                        <div className="col-lg-6 input-group">
                            <p>View Name <span style={{ color: '#f00' }}>*)</span></p>
                            <input className="form-control" type="text" value={viewName} name="viewName" onChange={e => this.setState({ viewName: e.target.value })} />
                            {errorMessage.viewName ? <p className="error-message">{errorMessage.viewName}</p> : ''}
                            <br />
                            <br />
                            <p>Assignment <span style={{ color: '#f00' }}>*)</span></p>
                            <div className="form-group">
                                <label className="radio-inline"><input type="radio" name="assignment" value="private" onChange={() => this.setState({ isPublic: false, profileId: '' })} checked={isPublic === false} /> Private</label>
                                <label className="radio-inline"><input type="radio" name="assignment" value="public" onChange={() => this.setState({ isPublic: true, profileId: '' })} /> Public</label>
                                <label className="radio-inline"><input type="radio" name="assignment" value="profile" checked={profileId !== ''} />
                                    <select
                                        name="profile"
                                        onChange={(e) => {
                                            if (e.target.value === '') {
                                                this.setState({ isPublic: false, profileId: '' });
                                            } else {
                                                this.setState({ isPublic: true, profileId: e.target.value });
                                            }
                                        }}
                                    >
                                        <option value=''>-- Profile --</option>
                                        {profileList.map(o => (
                                            <option value={o.id} selected={o.id === profileId}>{o.name}</option>
                                        ))}
                                    </select>
                                </label>
                            </div>
                        </div>
                    </div>
                    {/*
                        <div className="input-group flex checkbox">
                            <button
                                className={`btn btn-${isDefault ? 'success' : 'default'} active btn-sm`}
                                htmlFor="isDefault"
                                onClick={() => this.setState({ isDefault: !isDefault })}
                                style={{ marginRight: 10, height: 25, width: 25, padding: 0 }}
                            >
                                {isDefault ? <i className="fa fa-check" /> : <i className="fa" /> }
                            </button>
                            Default View
                        </div>
                    */}
                </div>
                {errorMessage.column ? <p className="error-message">{errorMessage.column}</p> : ''}
                <div className="row column-config">
                    <div className="available">
                        <p>Available Fields</p>
                        <select
                            className="form-control"
                            value={selectedObject}
                            onChange={(e) => {
                                const choosenObj2 = this.props.objDesc.find(o => o.name === e.target.value);
                                this.setState({ selectedObject: e.target.value, choosenObj: choosenObj2 });
                            }}
                        >
                            <option value="" />
                            <option value="Guest__c">Guest</option>
                            <option value="Sales_Order__c">Sales Order</option>
                            <option value="Opportunity">Opportunity</option>
                            <option value="Segment__c">Segment</option>
                            <option value="Room_Allocation__c">Room Allocation</option>
                            <option value="Account">Account</option>
                            <option value="Contact">Contact</option>
                            <option value="FormulaField">Formula Field</option>
                        </select>
                        <input
                            type="text"
                            className="form-control"
                            onChange={e => this.setState({ fieldFilter: e.target.value })}
                            placeholder="Filter"
                            value={fieldFilter}
                        />
                        <div className="field-box">
                            {choosenObj ? choosenObj.fields.map((o, index) => {
                                const isSelected = selectedColumn.findIndex(o2 => o2.objectName === selectedObject && o2.columnName === o.name);
                                if (isSelected > -1) return null;
                                if (o.label.toLowerCase().includes(fieldFilter.toLowerCase()) === false) return null;
                                return (
                                    <button
                                        className={`btn btn-block btn-${o.highlighted ? 'primary' : 'default'}`}
                                        key={o.name}
                                        onClick={e => this.toggleHighlightAvailableField(index, e.shiftKey)}
                                    >
                                        {o.label || o.columnName} <span style={{ fontWeight: 600 }} >({o.type})</span>
                                    </button>
                                );
                            }) : null}
                        </div>
                    </div>
                    <div className="add-remove-section">
                        <p>Add</p>
                        <button
                            className="btn btn-alternate "
                            onClick={() => {
                                const filtered = choosenObj.fields.filter(o => o.highlighted === true);
                                filtered.forEach((o) => {
                                    this.putInSelectedColumn(choosenObj.name, o.name, o.label, o.type);
                                });
                            }}
                        >
                            <i className="fa fa-chevron-right" />
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                selectedColumn.forEach((o, index) => {
                                    if (o.highlighted) {
                                        this.removeSelectedCol(index);
                                    }
                                });
                            }}
                        >
                            <i className="fa fa-chevron-left" />
                        </button>
                        <p>Remove</p>
                    </div>
                    <div className="selected">
                        <p>Selected Fields ({selectedColumn.length})</p>
                        <div className="field-box">
                            {selectedColumn.map((o, index) => (
                                <button
                                    className={`btn btn-block btn-${o.highlighted ? 'primary' : 'default'}`}
                                    key={`${o.columnName}${o.objectName}`}
                                    onClick={e => this.toggleHighlightSelectedCol(index, e.shiftKey)}
                                >
                                    {o.label}<span style={{ fontWeight: 600 }} >({o.type})</span>
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="add-remove-section">
                        <p>Up</p>
                        <button
                            className="btn btn-alternate "
                            onClick={() => this.reorderSelectedCol(-1)}
                            disabled={selectedColumn.filter(o => o.highlighted === true).length > 1}
                        >
                            <i className="fa fa-chevron-up" />
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.reorderSelectedCol(1)}
                            disabled={selectedColumn.filter(o => o.highlighted === true).length > 1}
                        >
                            <i className="fa fa-chevron-down" />
                        </button>
                        <p>Down</p>
                    </div>
                    <div className="selected" style={{ minWidth: 300, flex: 5 }}>
                        <p>
                            Sorting Order
                            <button className="btn btn-primary" style={{ marginLeft: 30 }} onClick={this.addSortOrderPlaceholder}>
                                <i className="fa fa-plus" />
                            </button>
                        </p>
                        <div className="row flex" style={{ flexDirection: 'column' }}>
                            {sortOrder.map((o, index) => (
                                <div className="flex filter-item" key={`filter${o.id}${index}`}>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => this.removeSortOrder(index)}
                                    >
                                        <i className="fa fa-minus" />
                                    </button>
                                    <select
                                        value={`${o.objectName}|${o.columnName}`}
                                        className="form-control"
                                        name={`columnName.${index}`}
                                        key={`columnName${index}`}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            const splittedValue = value.split('|');
                                            this.changeSortOrder('columnName', splittedValue[1], index);
                                            this.changeSortOrder('objectName', splittedValue[0], index);
                                        }}
                                    >
                                        <option />
                                        {selectedColumn.map(option => (
                                            <option value={`${option.objectName}|${option.columnName}`} key={option.columnName}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        value={o.operator}
                                        className="form-control"
                                        name={`operator${index}`}
                                        key={`operator${index}`}
                                        onChange={e => this.changeSortOrder('type', e.target.value, index)}
                                    >
                                        <option value="asc" selected={o.type === 'asc'}>Ascending</option>
                                        <option value="desc" selected={o.type === 'desc'}>Descending</option>
                                    </select>
                                </div>
                            ))}
                        </div>
                        <p>
                            Filter Criteria
                            <button className="btn btn-primary" style={{ marginLeft: 30 }} onClick={this.addFilterCriteriaPlaceholder}>
                                <i className="fa fa-plus" />
                            </button>
                        </p>
                        <div className="row flex" style={{ flexDirection: 'column' }}>
                            {filterCriteria.map((o, index) => (
                                <div className="flex filter-item" key={`filter${o.id}${index}`}>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => this.removeFilterCriteria(index)}
                                    >
                                        <i className="fa fa-minus" />
                                    </button>
                                    <select
                                        value={`${o.objectName}|${o.columnName}`}
                                        className="form-control"
                                        name={`columnName.${index}`}
                                        key={`columnName${index}`}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            const splittedValue = value.split('|');
                                            this.changeFilterCriteria('columnName', splittedValue[1], index);
                                            this.changeFilterCriteria('objectName', splittedValue[0], index);
                                        }}
                                    >
                                        <option />
                                        {selectedColumn.map(option => (
                                            <option value={`${option.objectName}|${option.columnName}`} key={option.columnName}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                    <select
                                        value={o.operator}
                                        className="form-control"
                                        name={`operator${index}`}
                                        key={`operator${index}`}
                                        onChange={e => this.changeFilterCriteria('operator', e.target.value, index)}
                                    >
                                        {
                                            OperatorList.map(option => (
                                                <option value={option.value}>{option.label}</option>
                                            ))
                                        }
                                    </select>
                                    <input
                                        type="text"
                                        value={o.filterValue}
                                        className="form-control"
                                        name={`filterValue${index}`}
                                        key={`filterValue${index}`}
                                        onChange={e => this.changeFilterCriteria('filterValue', e.target.value, index)}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


ColumnViewing.propTypes = {
    user: propTypes.object.isRequired,
    objDesc: propTypes.array.isRequired,
    history: propTypes.object.isRequired,
    match: propTypes.object.isRequired,
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    objDesc: state.salesforce.objDesc,
});


export default connect(mapStateToProps, mapDispatchToProps)(ColumnViewing);
